export default __webpack_public_path__ + "static/media/leader_notes.4c1b3aff.pdf";